import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "ds-calendar" }
const _hoisted_2 = {
  key: 0,
  class: "qalendar-event__time"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "date_range", -1)
const _hoisted_4 = {
  key: 1,
  class: "qalendar-event__time"
}
const _hoisted_5 = { class: "qalendar-event__title" }
const _hoisted_6 = { class: "qalendar-event is-week" }
const _hoisted_7 = { class: "qalendar-event__title" }
const _hoisted_8 = { class: "qalendar-event__time" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Qalendar = _resolveComponent("Qalendar")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Qalendar, {
      events: _ctx.calendarEvents,
      config: _ctx.calendarConfig,
      onEventWasClicked: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('event-click', $event.clickedEvent))),
      onEditEvent: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('edit-event', $event))),
      onDeleteEvent: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('delete-event', $event))),
      onUpdatedPeriod: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('updated-period', $event))),
      onUpdatedMode: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('updated-mode', $event)))
    }, {
      monthEvent: _withCtx(({ eventData }) => [
        _renderSlot(_ctx.$slots, "event", {
          event: eventData,
          view: "month"
        }, () => [
          _withDirectives((_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["qalendar-event", _ctx.rangeClasses(eventData)])
          }, [
            (_ctx.showsRangeLabel(eventData))
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                  _hoisted_3,
                  _createTextVNode(" " + _toDisplayString(eventData.rangeLabel || _ctx.eventRange(eventData)), 1)
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.eventHour(eventData)), 1)),
            _createElementVNode("span", _hoisted_5, _toDisplayString(eventData.title), 1)
          ], 2)), [
            [
              _directive_tooltip,
              _ctx.eventTooltip(eventData),
              void 0,
              { top: true }
            ]
          ])
        ])
      ]),
      weekDayEvent: _withCtx(({ eventData }) => [
        _renderSlot(_ctx.$slots, "event", {
          event: eventData,
          view: "week"
        }, () => [
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, _toDisplayString(eventData.title), 1),
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.eventHour(eventData)), 1)
          ])), [
            [
              _directive_tooltip,
              _ctx.eventTooltip(eventData),
              void 0,
              { top: true }
            ]
          ])
        ])
      ]),
      eventDialog: _withCtx(({ closeEventDialog }) => [
        _renderSlot(_ctx.$slots, "eventDialog", { close: closeEventDialog })
      ]),
      _: 3
    }, 8, ["events", "config"])
  ]))
}